import nacl from "tweetnacl";
import * as naclUtil from "tweetnacl-util";

const secretKey = naclUtil.decodeBase64(import.meta.env.VITE_SECRET_KEY);

export const decryptResponse = (encryptedData, nonce) => {
  try {
    const decrypted = nacl.secretbox.open(
      naclUtil.decodeBase64(encryptedData),
      naclUtil.decodeBase64(nonce),
      secretKey
    );

    if (!decrypted) {
      throw new Error("Decryption failed");
    }

    return JSON.parse(naclUtil.encodeUTF8(decrypted));
  } catch (err) {
    console.error(err);
    return null;
  }
};